Function.prototype.curry = function curry() {
  var fn = this, args = Array.prototype.slice.call(arguments);
  return function curryed() {
    return fn.apply(this, args.concat(Array.prototype.slice.call(arguments)));
  };
};

define("lib/prototype/Function.prototype", function(){});

